import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
// Material UI Components
import { IconButton, Tooltip } from "@mui/material";

// Material UI Icons
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import { cilAccountLogout } from "@coreui/icons";
import {
  CBadge,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
  CSidebarNav,
  CSidebarToggler,
  CNavItem,
  CNavTitle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { CButton } from "@coreui/react";
import {
  cilMap, // Destinos
  cilBullhorn, // Publicidad
  cilImage, // Slides
  cilUser, // Usuarios
  cilHome, // Inicio
} from "@coreui/icons";
import { styled } from "@mui/system";
import Juliaca from "../../assets/img/Juliaca.png";

const LogoContainer = styled("div")`
  display: flex;
  align-items: center;
`;

const AdminCruds = () => {
  const storedUser = sessionStorage.getItem("name");
  const role = sessionStorage.getItem("role");
  const isAdmin = role === "admin";
  const isSuperAdmin = role === "superadmin";
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/");
  };

  return (
    <CSidebar className="border-end">
      {/* Brand */}
      <CSidebarHeader className="border-bottom">
        <LogoContainer>
          <img
            src={Juliaca}
            alt="San Román"
            style={{ height: "50px", width: "185px" }}
          />
        </LogoContainer>
      </CSidebarHeader>

      {/* Sidebar Nav */}
      <CSidebarNav>
        <CNavTitle>CRUDS ADMINISTRATIVOS</CNavTitle>

      {(isAdmin || isSuperAdmin) && (
        <>
          <CNavItem>
            <NavLink to="/admin/destinos" className="nav-link">
              <CIcon customClassName="nav-icon" icon={cilMap} /> Destinos
            </NavLink>
          </CNavItem>

          <CNavItem>
            <NavLink to="/admin/publicidads" className="nav-link">
              <CIcon customClassName="nav-icon" icon={cilBullhorn} /> Publicidades
            </NavLink>
          </CNavItem>

          <CNavItem>
            <NavLink to="/admin/slides" className="nav-link">
              <CIcon customClassName="nav-icon" icon={cilImage} /> Slides
            </NavLink>
          </CNavItem>
        </>
      )}

      {isSuperAdmin && (
        <CNavItem>
          <NavLink to="/admin/usuarios" className="nav-link">
            <CIcon customClassName="nav-icon" icon={cilUser} /> Usuarios
          </NavLink>
        </CNavItem>
      )}

      </CSidebarNav>

      {/* Saludo y Logout */}
      {storedUser && (
        <CSidebarHeader className="border-top">
          <div
            style={{
              padding: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <span>¡Hola, {storedUser.split(" ")[0]}!</span>
          </div>
          <Tooltip title="Cerrar sesión">
            <IconButton onClick={goHome} sx={{ color: "#2a3b87" }}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </CSidebarHeader>
      )}
    </CSidebar>
  );
};

export default AdminCruds;
